/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Type } from '@spotify-internal/encore-creator-web';
import get from 'lodash/get';
import styles from './index.module.css';
import { PreviewPanePodcast } from '../../../types';

interface Props {
  rssFeed: PreviewPanePodcast | null;
}

export function ReleasePreviewThin({ rssFeed }: Props) {
  return (
    <aside className={styles.thin_container}>
      <section className={styles.description_container}>
        {get(rssFeed, 'description') ? (
          <Type
            as="p"
            variant={Type.body2}
            color="gray60"
            className={styles.description}
            condensed
            dangerouslySetInnerHTML={{ __html: get(rssFeed, 'description') }}
          />
        ) : null}
      </section>
      <section className={styles.categories_container}>
        {get(rssFeed, 'itunesCategories') ? (
          <Type as="p" variant={Type.body2} color="white" condensed>
            {rssFeed && rssFeed.itunesCategories!.map(itc => itc.name).join(', ')}
          </Type>
        ) : null}
      </section>
    </aside>
  );
}

ReleasePreviewThin.propTypes = {
  rssFeed: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.string,
    description: PropTypes.string,
    language: PropTypes.string,
    itunesCategories: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ),
  }),
};

ReleasePreviewThin.defaultProps = {
  rssFeed: {},
};
